// extracted by mini-css-extract-plugin
export default {"container":"EditRoomPage_container__2wXlM","patientQueue":"EditRoomPage_patientQueue__f6ad6"};